import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import brochure_bg from '../../assets/images/brochure_bg.webp';
// import MuiImageSlider from 'mui-image-slider';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

import industries_1 from '../../assets/images/industries_1.jpg';
import industries_2 from '../../assets/images/industries_2.jpg';
import industries_3 from '../../assets/images/industries_3.jpg';


import industries_4 from '../../assets/images/industries_4.jpg';

import brochureBg from '../../assets/images/brochure_bg.webp';


import slider1 from '../../assets/images/slider1.jpeg';
import slider2 from '../../assets/images/slider2.jpeg';
import slider3 from '../../assets/images/slider3.jpeg';
import slider4 from '../../assets/images/slider4.jpeg';


const images = [
  'https://homepages.cae.wisc.edu/~ece533/images/airplane.png',
  'https://homepages.cae.wisc.edu/~ece533/images/arctichare.png',
  'https://homepages.cae.wisc.edu/~ece533/images/baboon.png',
  'https://homepages.cae.wisc.edu/~ece533/images/barbara.png',
];

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  speed: 10000,
  autoplaySpeed: 2000,
  // cssEase: "linear",
  // className: "center",
  // centerMode: true,
  // centerPadding: "60px",
  adaptiveHeight: true,
  // dots: true,
  // infinite: true,
  // speed: 500,
  // slidesToShow: 3,
  // slidesToScroll: 3
  nextArrow:<></>,
  prevArrow:<></>,

};

const BrochureContent = styled('div')({
  // backgroundColor:'green'
  maxWidth: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
  zIndex: 2,
});

const Brochure = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="slider-container" >
      <Slider {...settings}>
        <div style={{ width: 280, height: 300 }}>
          <img
            src={slider1}
            width={'97%'}
            height={400}
            style={{ backgroundRepeat: 'no-repeat', objectFit: 'cover' }}
          />
        </div>
        <div style={{ width: 280, height: 300 }}>
          <img
            src={slider2}
            width={'97%'}
            height={400}
            style={{ backgroundRepeat: 'no-repeat', objectFit: 'cover' }}
          />
        </div>
        <div style={{ width: 280, height: 300 }}>
          <img
            src={slider3}
            width={'97%'}
            height={400}
            style={{ backgroundRepeat: 'no-repeat', objectFit: 'cover' }}
          />
        </div>
        <div style={{ width: 280, height: 300 }}>
          <img
            src={slider4}
            width={'97%'}
            height={400}
            style={{ backgroundRepeat: 'no-repeat', objectFit: 'cover' }}
          />
        </div>
      </Slider>
    </div>

   
  );
};

export default Brochure;



 // <Box
    //   sx={{
    //     position: 'relative',
    //     height: '500px',
    //     width: '100%',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
    //     '&::before': {
    //       content: '""',
    //       position: 'absolute',
    //       top: 0,
    //       left: 0,
    //       right: 0,
    //       bottom: 0,
    //       backgroundImage: `url(${brochure_bg})`,
    //       backgroundRepeat: 'no-repeat',
    //       backgroundSize: '100%',
    //       opacity: 0.4,
    //       zIndex: 1
    //     }
    //   }}
    // >
    //   <BrochureContent>
    //     <Typography
    //       variant='h2'
    //       component='h2'
    //       sx={{
    //         margin: '16px 0px',
    //         color: 'rgb(154,74,32)',
    //         fontWeight: 100,
    //         fontFamily: i18n.language === 'ar' ? 'Arial, sans-serif' : 'inherit',
    //         textAlign: 'center'
    //       }}
    //     >
    //       {t('brochure.title')}
    //     </Typography>
    //     <Typography
    //       variant='h6'
    //       component='h6'
    //       sx={{
    //         margin: '16px 0px',
    //         color: 'rgb(154,74,32)',
    //         fontWeight: 100,
    //         fontFamily: i18n.language === 'ar' ? 'Arial, sans-serif' : 'inherit',
    //         textAlign: 'center'
    //       }}
    //     >
    //       {t('brochure.subtitle')}
    //     </Typography>
    //   </BrochureContent>
    // </Box>